export default function EnabledBadge(props) {
    return <span class={`badge ${props.enabled ? "bg-success" : "bg-danger"}`}>{props.enabled ? "Oui" : "Non"}</span>;
}
